import { createInjectionKey as n } from "./highrise529.mjs";
const e = n("n-input");
export {
  e as inputInjectionKey
};
